import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedGrid from './components/FeaturedGrid';
import AnimeGrid from './components/AnimeGrid';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="樱花动漫-专注手机动漫的门户网站-动漫大全-樱花动漫网"
        description="如果您是手机动漫迷，樱花动漫网提供全面的动漫大全资源，这个门户网站专为移动端优化，让您轻松浏览和观看各种动漫，随时随地满足您的娱乐需求。"
        keywords="樱花动漫,手机动漫门户,动漫大全,移动动漫资源"
        canonicalUrl="http://knsink.cn/"
        ogType="website"
        ogImage="https://readdy.ai/api/search-image?query=Dreamy%20ethereal%20cherry%20blossom%20anime%20landscape%20with%20soft%20pink%20petals%20floating%20in%20the%20air%2C%20warm%20golden%20sunset%20light%2C%20traditional%20Japanese%20temple%20silhouette%20in%20the%20distance%2C%20artistic%20painterly%20style%2C%20atmospheric%20cinematic%20composition&width=1200&height=630&seq=home-og-image&orientation=landscape"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '樱花动漫',
            url: 'http://knsink.cn/',
            description: '专注手机动漫的门户网站，提供全面的动漫大全资源，让您轻松浏览和观看各种动漫。',
            address: {
              '@type': 'PostalAddress',
              streetAddress: '朝阳区动漫产业园区 A座 1208室',
              addressLocality: '北京',
              addressRegion: '北京',
              addressCountry: 'CN',
            },
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '+86-400-888-0666',
              contactType: 'customer service',
              availableLanguage: ['Chinese'],
            },
            sameAs: [
              'http://knsink.cn/',
            ],
          },
          {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '樱花动漫',
            url: 'http://knsink.cn/',
            description: '专注手机动漫的门户网站，提供全面的动漫大全资源',
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: 'http://knsink.cn/search?q={search_term_string}',
              },
              'query-input': 'required name=search_term_string',
            },
            inLanguage: 'zh-CN',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'http://knsink.cn/',
              },
            ],
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '樱花动漫网提供哪些类型的动漫资源？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '樱花动漫网提供热血战斗、奇幻冒险、恋爱日常、搞笑喜剧、悬疑推理、科幻机甲、治愈日常、异世界、偶像音乐、运动竞技等全类型动漫资源，覆盖日本动漫、国产动漫和欧美动漫。',
                },
              },
              {
                '@type': 'Question',
                name: '樱花动漫网是否针对手机端进行了优化？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '是的，樱花动漫网专为手机动漫迷打造，采用了移动端优先的设计理念，加载速度快，排版舒适，让您随时随地畅享二次元世界的精彩内容。',
                },
              },
              {
                '@type': 'Question',
                name: '樱花动漫网的内容更新频率如何？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '樱花动漫网每日更新最新番剧和动漫资讯，确保用户不会错过任何一部好番。我们的编辑团队持续跟踪动漫行业动态，为您提供及时、全面的内容。',
                },
              },
            ],
          },
        ]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedGrid />
        <AnimeGrid />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}